import React from "react";

import Items from "components/Tables/Items/Items";

const ListItem = () => {
  return (
    <div>
      <Items />
    </div>
  );
};

export default ListItem;
